import { SettingsManager } from "@viamap/viamap2-common";
import { EjendomTingbog } from "./DLLTypes";
import { removeXmlNsPrefix } from "src/functions/WFSutils";

export class tinglysningCollector {

   static async EjendomSoeg(EjendomSoegLookup: EjendomSoegLookup): Promise<any> {
      console.log(EjendomSoegLookup);
      const body = {
         ...EjendomSoegLookup,
         "format": "xml"
      }
      return fetchEtlService("ejendomSoeg", body).then((response) => {
         if (!response.ok) {
            throw new Error("Network response was not ok");
         }
         return response.json();
      }).then((body) => {
         let parser = new DOMParser();
         let xmlNoTags = removeXmlNsPrefix(body.body);
         return parser.parseFromString(xmlNoTags, "application/xml");
      }).catch((error) => {
         console.error("Error fetching EjendomSoeg:", error);
         throw new Error(error instanceof Error ? error.message : "Error fetching EjendomSoeg");
      });
   }

   static async EjendomSummariskPDF(matrikelListe: { matnr: string, elav: string }[]): Promise<Blob> {
      const body = {
         "matrikelListe": matrikelListe.map(({ matnr, elav }) => {
            let digits = matnr.replace(/\D/g, "");
            let letter = matnr.replace(/\d/g, "").trim();
            return {
               "matnr": digits.padStart(4, "0") + letter,
               "elav": elav + ""
            }
         }),
         "format": "pdf"
      }
      return fetchEtlService("getEjendomSummarisk", body).then((response) => {
         if (!response.ok) {
            throw new Error("Network response was not ok");
         }
         return response.json();
      }).then((body) => {
         const base64Data = body.body;
         const binaryData = Uint8Array.from(atob(base64Data), c => c.charCodeAt(0));
         return new Blob([binaryData], { type: "application/pdf" });
      })
   }

   static async EjendomTingbog(BFENummer: string): Promise<EjendomTingbog> {
      const body = {
         "BFEnr": BFENummer
      }
      return fetchTL("getTinglysningsData", body);
   }

   static async DokumentTingbog(uuid: string): Promise<XMLDocument> {
      const body = {
         "uuid": uuid
      }
      let reps = await fetchTL("getTinglysningsDokument", body);
      try {
         let parser = new DOMParser();
         let xmlNoTags = removeXmlNsPrefix(reps);
         return parser.parseFromString(xmlNoTags, "application/xml");
      } catch (error: Error | any) {
         console.error("Error parsing XML:", error?.message ?? error);
         throw new Error("Expected XML response");
      }
   }

   static async fetchServitutBilag(bilagRef: string): Promise<{ data: Blob, name: string } | undefined> {
      const body = {
         "BilagDokumentId": bilagRef
      }
      return await fetchEtlService("getTinglysningsBilag", body).then((response) => {
         if (!response.ok) {
            throw new Error("Network response was not ok");
         }
         return response.json();
      }).then((body) => {
         const statusCode = Number(body?.statusCode);
         if (!Number.isNaN(statusCode) && statusCode >= 400) {
            throw new Error(body?.body || "Failed to fetch appendix data");
         }

         if (!body?.body || typeof body.body !== "string") {
            throw new Error("Invalid appendix response");
         }

         let xmlText = body.body;
         try {
            xmlText = JSON.parse(body.body);
         } catch {
            // Keep raw body when it is already plain XML.
         }

         let removedNsXml = removeXmlNsPrefix(xmlText);
         let xml = new DOMParser().parseFromString(removedNsXml, "application/xml");
         let name = xml.getElementsByTagName("Titel")[0]?.textContent || "bilag";
         let data = xml.getElementsByTagName("AttachmentBinaryData")[0];
         let mime = data?.getAttribute("mimetypeCode") || "application/pdf";
         let base64Data = data?.textContent || "";
         let blob = new Blob([Uint8Array.from(atob(base64Data), c => c.charCodeAt(0))], { type: mime });
         return { data: blob, name: name + "." + mime.split("/").at(-1) };
      }).catch((error) => {
         console.error("Error fetching bilag:", error);
         throw new Error(error instanceof Error ? error.message : "Error fetching bilag");
      });
   }
}

async function fetchEtlService(endpoint: string, body: any): Promise<Response> {
   const baseUrl = SettingsManager.getSystemSetting("eTLServicesUrl");
   const url = baseUrl + "/" + endpoint;
   const API_KEY = SettingsManager.getSystemSetting("eTLServicesKey");

   return await fetch(url, {
      method: "POST",
      headers: {
         "Content-Type": "application/json",
         "x-api-key": API_KEY
      },
      body: JSON.stringify(body)
   })
}

/**
 * @deprecated Use fetchEtlService instead for new endpoints, as the DLL services are being phased out.
 */
async function fetchTL(endpoint: string, body: any): Promise<any> {
   const baseUrl = SettingsManager.getSystemSetting("dllServicesUrl");
   const url = "https://" + baseUrl + "/" + endpoint;
   const API_KEY = SettingsManager.getSystemSetting("dllServicesKey");

   return await fetch(url, {
      method: "POST",
      headers: {
         "x-api-key": API_KEY ? API_KEY : "",
         "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
   }).then((response) => {
      if (!response.ok) {
         throw new Error("Network response was not ok");
      }
      if (response.headers.get("Content-Type")?.includes("application/json")) {
         return response.json();
      }
      return response.text();
   });
}

type EjendomSoegLookup = {
   dokumentAlias?: string;
   dokumentAliasHist?: string;
   dokumentID?: string;
   rettighedID?: string;
   side?: string;
};